export enum RequestStatus {
    SOLVED = "Solucionado",
    PENDING = "Pendiente",
    NOT_SOLVED = "No Solucionado",
}
